module.exports = __webpack_public_path__ + "6994d69652dca68ec4f03ef36408884a.pdf";